import { createSlice } from '@reduxjs/toolkit';

import { SyncPair } from '~/api/evisync';
import { ManageSyncPairStageType } from '~/enums/ManageSyncPairStageType';
import { fromArray } from '~/utils/object';

interface IntegrationsState {
  manageSyncPairStage: ManageSyncPairStageType;
  tableState: { pageIndex: number; pageSize: number };
  syncPairs: Record<string, SyncPair>;

  activeSyncPair?: SyncPair;
}

export const initialState: IntegrationsState = {
  activeSyncPair: undefined,
  manageSyncPairStage: ManageSyncPairStageType.None,
  tableState: { pageIndex: 1, pageSize: 10 },
  syncPairs: [] as any,
};

export default createSlice({
  name: 'integrations',
  initialState,
  selectors: {
    selectActiveSyncPair: (state) => state.activeSyncPair,
    selectManageSyncPairStage: (state) => state.manageSyncPairStage,
    selectSyncPairs: (state) => state.syncPairs,
    selectTableState: (state) => state.tableState,
  },
  reducers: {
    setActiveSyncPair: (state, action) => {
      state.activeSyncPair = action.payload;
    },
    setManageSyncPairStage: (state, action) => {
      state.manageSyncPairStage = action.payload;
    },
    addSyncPair: (state, action) => {
      const newSyncPair = action.payload;
      state.syncPairs[newSyncPair.id] = newSyncPair;
    },
    removeSyncPair: (state, action) => {
      delete state.syncPairs[action.payload.id];
    },
    setSyncPairs: (state, action) => {
      state.syncPairs = fromArray(action.payload, 'id');
    },
    setManageSyncPairPageIndex: (state, action) => {
      const { pageIndex = 1 } = action.payload;
      state.tableState.pageIndex = pageIndex;
    },
    setManageSyncPairPageSize: (state, action) => {
      const { pageSize = 10 } = action.payload;
      state.tableState.pageSize = pageSize;
    },
  },
});
